<!--
 * @Description: 东西方老师排行榜 -- PC端
 * @Author: xiuwen
 * @Date: 2024-12-27 14:21:38
 * @LastEditors: xiuwen
 * @LastEditTime: 2025-06-24 11:25:41
-->
<template>
	<section class="pc-card">
		<img class="pc-card-title" :src="type === 'dongfang' ? dongfangImg : tarotImg" alt="" />
		<ul class="pc-list">
			<li
				v-for="(item, index) in data.slice(0, 3)"
				:key="index"
				class="pc-list-item"
				@click="goTeacherDetail(item.teacher_id)"
			>
				<div class="pc-list-item-left">
					<img class="icon" :src="rankImg[index]" alt="" />
					<img class="avatar" :src="item.avatar" alt="" />
				</div>
				<div class="pc-list-item-right">
					<div>
						<span class="nickname">{{ item.nickname }}</span>
						<span class="year">從業{{ item.year }}</span>
					</div>
					<div class="tag-box">
						<span v-for="(v, index) in item?.academic_sector.split(',')" :key="index" class="tag">{{
							v
						}}</span>
					</div>
				</div>
			</li>
		</ul>
	</section>
</template>

<script setup>
// 图片
import rank1 from "~/assets/images/pc/rank1.png";
import rank2 from "~/assets/images/pc/rank2.png";
import rank3 from "~/assets/images/pc/rank3.png";
import { logEvent } from "~/utils/firebase";
import dongfangImg from "./images/dongfang.png";
import tarotImg from "./images/tarot.png";

const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
	type: {
		type: String,
		default: "",
	},
});

const rankImg = [rank1, rank2, rank3];

const goTeacherDetail = id => {
	if (import.meta.client) {
		logEvent(props.type === "dongfang" ? "site_master_east" : "site_master_west");
	}
	navigateTo({
		path: `/seer/teacher-detail/${id}`,
	});
};
</script>

<style lang="scss" scoped>
.pc-card {
	width: 571px;
	height: 433px;
	background-color: #ffffff;
	border-radius: 8px;
	font-family: PingFang SC;
	overflow: hidden;

	.pc-card-title {
		width: 571px;
		height: 120px;
	}

	.pc-list {
		.pc-list-item {
			display: flex;
			margin: 10px 7px 0;
			width: 550px;
			height: 90px;
			position: relative;
			cursor: pointer;

			&::after {
				content: "";
				height: 1px;
				width: 550px;
				border-bottom: 1px dashed rgba(217, 217, 255, 0.5);
				position: absolute;
				bottom: 0;
				left: 50%;
				transform: translateX(-50%);
			}

			&:last-child::after {
				display: none;
			}

			.pc-list-item-left {
				margin-left: 32px;
				margin-right: 14px;
				width: 66px;
				height: 66px;
				position: relative;

				.avatar {
					width: 66px;
					height: 66px;
					object-fit: cover;
					border-radius: 4px;
					background:
						linear-gradient(180deg, #d2af8e 0%, #faeee2 100%),
						linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
				}

				.icon {
					width: 45px;
					height: 24px;
					position: absolute;
					top: 50%;
					left: 0;
					transform: translate(-50%, -50%);
				}
			}

			.pc-list-item-right {
				.nickname {
					margin-right: 9px;
					font-weight: 500;
					font-size: 18px;
					color: #333333;
					line-height: 28px;
				}

				.year {
					font-size: 16px;
					color: #666666;
					line-height: 24px;
				}

				.tag-box {
					margin-top: 8px;
					height: 19px;
					display: flex;
					flex-wrap: wrap;
					overflow: hidden;

					.tag {
						margin-right: 8px;
						font-size: 16px;
						color: #c78234;
						line-height: 19px;
					}
				}
			}
		}
	}
}
</style>
